// İzin türünün hak ediş biçimi ve devir tavanı alanları — kiracı izin türü formu
// (pages/leave-types) ile global şablon düzenleyicisi (LeavePolicyTemplateVariationsEditor)
// AYNI kuralları paylaşır. Backend karşılığı: Common/LeaveAccrualValidator.cs.

export const ACCRUAL_FREQUENCIES = ['yearly', 'monthly'];
export const ACCRUAL_ROUNDINGS = ['exact', 'halfDown'];
export const MAX_ELIGIBILITY_MONTHS = 12;
export const MAX_EXPIRY_MONTHS = 11;
// AKM POC §6.4 — 657 md.103: yıllık izin bir önceki yıldan devreder, devir süresi bir yıl (12 ay).
// Backend: LeaveAccrual.MaxExpiryMonths657.
export const MAX_EXPIRY_MONTHS_657 = 12;

export const TURKIYE = 'TR';

export const isMonthly = (v) => v?.accrualFrequency === 'monthly';

// Yasal yıllık izin: bakiye ekseni ya da kategori "annual".
export const isStatutoryAnnual = (v) => v?.balanceScope === 'annual' || v?.category === 'annual';

// Yasal çerçeve (backend LegalFramework SAYI olarak serileşir): 0 = 4857 İş Kanunu, 1 = 657 Devlet
// Memurları Kanunu. Alan yoksa (eski kayıt / çerçevesiz şablon türü) 4857 kabul edilir.
export const LABOR_4857 = 0;
export const CIVIL_SERVANT_657 = 1;
export const legalFrameworkOf = (v) => {
  const lf = v?.legalFramework;
  return lf === '' || lf === null || lf === undefined ? LABOR_4857 : Number(lf);
};

// Türkiye'de yasal yıllık izne devir tavanı / devir süresi KONAMAZ (4857 s. İş Kanunu
// m.53 — yıllık ücretli izin hakkından vazgeçilemez, kullanılmayan izin yanmaz).
// countryCode null/undefined → Türkiye kabul edilir (kiracı bağlamı okunamadıysa güvenli
// taraf — backend TenantCountryResolver ile aynı). Boş dizge ('') "ülkesiz" demektir:
// ülkesi seçilmemiş global şablonu backend de kilitlemez (LeaveAccrualValidator).
// AKM POC §6.4 — kilit YALNIZ 4857'dedir: 657 md.103'e göre yıllık izin yalnız bir önceki yıldan
// devreder (devir süresi kanunun kendisi) — backend LeaveAccrualValidator ile aynı kural.
export const isCarryOverLocked = (v, countryCode) =>
  String(countryCode ?? TURKIYE).toUpperCase() === TURKIYE
  && isStatutoryAnnual(v)
  && legalFrameworkOf(v) === LABOR_4857;

// Devir süresi üst sınırı türün yasal çerçevesine göre: 657'de 12 ay, diğerlerinde 11 ay.
export const maxExpiryMonthsFor = (v) => (legalFrameworkOf(v) === CIVIL_SERVANT_657 ? MAX_EXPIRY_MONTHS_657 : MAX_EXPIRY_MONTHS);

// Devir tavanı alanları yalnız DEVREDEN ve kilitli OLMAYAN türde anlamlıdır.
export const canUseCarryOver = (v, countryCode) => !!v?.carriesForward && !isCarryOverLocked(v, countryCode);

const bosMu = (x) => x === '' || x === undefined || x === null;

// Gönderimden önce: boş sayısal alan null'a (System.Text.Json "" okuyamaz → 400), yıllık
// türde aylık-özel alanlar varsayılana, görünmeyen (devretmeyen / kilitli) türde tavan ve
// süre null'a indirilir. Form gizli alanın eski değerini formData'da tuttuğu için bu
// temizlik yapılmazsa kullanıcının GÖREMEDİĞİ bir değer yüzünden kayıt reddedilirdi.
export const normalizeAccrualFields = (v, countryCode) => {
  const out = { ...v };
  out.accrualFrequency = ACCRUAL_FREQUENCIES.includes(out.accrualFrequency) ? out.accrualFrequency : 'yearly';
  out.accrualRounding = ACCRUAL_ROUNDINGS.includes(out.accrualRounding) ? out.accrualRounding : 'exact';
  out.accrualEligibilityMonths = bosMu(out.accrualEligibilityMonths) ? 0 : Number(out.accrualEligibilityMonths);
  out.accrualTopUpAtAnniversary = !!out.accrualTopUpAtAnniversary;
  out.carryOverCap = bosMu(out.carryOverCap) ? null : Number(out.carryOverCap);
  out.carryOverExpiryMonths = bosMu(out.carryOverExpiryMonths) ? null : Number(out.carryOverExpiryMonths);

  if (out.accrualFrequency === 'yearly') {
    out.accrualEligibilityMonths = 0;
    out.accrualTopUpAtAnniversary = false;
    out.accrualRounding = 'exact';
  }
  if (!canUseCarryOver(out, countryCode)) {
    out.carryOverCap = null;
    out.carryOverExpiryMonths = null;
  }
  return out;
};
